import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import { setIsAssignedToChanged, setIsEditing, setIsEditSheetOpen } from "./slice";

export const useEditingDocument = () => {
    const dispatch = useAppDispatch();
    const editDocumentSelector = useAppSelector(state => state.editDocuments);

    return {
        isEditing: editDocumentSelector.isEditing,
        isAssignedToChanged: editDocumentSelector.isAssignedToChanged,
        isEditSheetOpen: editDocumentSelector.isEditSheetOpen,
        setIsEditing: (payload: boolean) => dispatch(setIsEditing(payload)),
        setIsAssignedToChanged: (payload: boolean) => dispatch(setIsAssignedToChanged(payload)),
        setIsEditSheetOpen: payload => dispatch(setIsEditSheetOpen(payload)),
    };
};
